/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:c51b3ba8-83f6-43c6-9c1d-977e9d076224",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_KNidI2K3P",
    "aws_user_pools_web_client_id": "7g3dl3t8a4padl7tvmsn2d9sch",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "inno-wise-snapshots-fmcsa-app6bb7b-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
